import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Dice5, Shield, BarChart3, Scale, Ban, Info } from "lucide-react";
import { api } from "../lib/api";

const CONTAINER = "mx-auto max-w-[920px] px-4 sm:px-8 lg:px-12";

const ICONS = [Dice5, Shield, BarChart3, Scale, Ban, Info];

export default function SportsbookMethodologyPage() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/sportsbook/methodology").then((r) => setData(r.data)).catch(() => setData(null));
  }, []);
  return (
    <div className="animate-fade-up pb-20" data-testid="sportsbook-methodology-page">
      <section className="relative overflow-hidden border-b border-[rgba(212,175,55,0.22)] bg-[#000000]">
        <div className="absolute inset-0 mesh-grid opacity-[0.14] pointer-events-none" />
        <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(120% 140% at 50% 0%, rgba(212,175,55,0.14) 0%, transparent 55%)" }} />
        <div className={`${CONTAINER} relative py-10 sm:py-14`}>
          <Link to="/rankings" data-testid="methodology-back" className="inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-[#E5B842] mb-5" style={{ transition: "color 0.15s ease" }}>
            <ArrowLeft className="w-4 h-4" /> Rankings
          </Link>
          <div className="text-[11px] uppercase tracking-[0.3em] text-[#E5B842] font-mono font-bold mb-2">Methodology</div>
          <h1 data-testid="methodology-title" className="font-heading text-4xl sm:text-5xl font-black uppercase tracking-tight text-slate-50 leading-none wsbf-slant-block">
            Sportsbook Rating
          </h1>
          <p className="text-slate-400 mt-3 text-sm sm:text-base">
            How WSTF rates player vs operator betting coupon settlements — PREGAME and LIVE kept separate, no stake data ever used.
          </p>
          <div className="text-[11px] font-mono uppercase tracking-widest text-slate-500 mt-4" data-testid="methodology-version">
            Calculation version: <span className="text-[#E5B842]">{data?.version || "SPORTSBOOK_V1"}</span>
          </div>
        </div>
      </section>
      <div className={`${CONTAINER} pt-10 space-y-5`}>
        {(data?.sections || []).map((s, i) => {
          const Icon = ICONS[i % ICONS.length];
          return (
            <div key={s.title} data-testid={`methodology-section-${i}`} className="rounded-xl bg-[#141414] border border-[rgba(212,175,55,0.18)] p-5 sm:p-6">
              <div className="flex items-center gap-2.5 mb-3">
                <span className="shrink-0 grid place-items-center w-9 h-9 rounded-full bg-[#0c0c0c] border border-[#E5B842]/30">
                  <Icon className="w-4 h-4 text-[#E5B842]" />
                </span>
                <h2 className="font-heading text-lg font-black uppercase tracking-tight text-slate-100">{s.title}</h2>
              </div>
              <p className="text-sm text-slate-300 leading-relaxed">{s.body}</p>
            </div>
          );
        })}
        <div className="text-center text-[11px] font-mono text-slate-500 uppercase tracking-widest pt-6">
          Sportsbook is independent from ArenaBook, Challenge, Strike 5 and the WSTF Overall rating.
        </div>
      </div>
    </div>
  );
}
